// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3ziOh","imageUploader":"EGiftCard_imageUploader__1XvU5"};